/* global axios */
import ApiClient from './ApiClient';

class AttachmentsAPI extends ApiClient {
  constructor() {
    super('attachments', { accountScoped: true });
  }

  retryTranscription(attachmentId) {
    return axios.post(`${this.url}/${attachmentId}/retry_transcription`);
  }
}

export default new AttachmentsAPI();
